import { IDictionaryModel } from "../../models/response/dictionary";
import { DictionaryActionTypeIds, DictionaryActionTypes } from "../action-types/dictionaryActionTypes";
interface DictionaryState {
    lan: string
    dictionary: IDictionaryModel[],
    translate: (vi: string) => string
}
const initialState: DictionaryState = {
    lan: "vi",
    dictionary: [],
    translate: (vi: string) => {
        return vi;

    }
}
export const dictionaryReducer = (state: DictionaryState = initialState, action: DictionaryActionTypes): DictionaryState => {
    switch (action.type) {
        case DictionaryActionTypeIds.SET_DICTIONARY:
            return {
                ...state,
                dictionary: action.payload
            }
        default:
            return state;
    }

}
